import { useCallback, useRef } from "react";

type Params = {
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void | Promise<void>;
};

type Result = {
  lastItemRef: (node: HTMLDivElement | null) => void;
};

export const useInfiniteScrollTrigger = ({
  hasMore,
  loading,
  onLoadMore,
}: Params): Result => {
  const observer = useRef<IntersectionObserver | null>(null);

  const lastItemRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (loading) return;

      if (observer.current) {
        observer.current.disconnect();
      }

      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0]?.isIntersecting && hasMore) {
            onLoadMore();
          }
        },
        { threshold: 1 }
      );

      if (node) {
        observer.current.observe(node);
      }
    },
    [hasMore, loading, onLoadMore]
  );

  return { lastItemRef };
};